import React, { forwardRef, ComponentType } from 'react';
import { useLocation, useParams, matchRoutes, RouteMatch } from 'react-router-dom';
import useHistory from './useHistory';
import {
  ROOT_FOLDER,
  EVENT,
  EDIT,
  AUTHORIZE,
  MEMBER_PROFILE_MOBILE_SCREEN,
  QUICK_REG_SHORT_LINK,
} from 'redhotpie-shared-lib/constants/routes';

export interface IWithRoutes {
  location: ReturnType<typeof useLocation> & { reload: () => void };
  history: ReturnType<typeof useHistory>;
  params: ReturnType<typeof useParams>;
  match: RouteMatch | null;
}

const parentPath = [
  {
    path: `${ROOT_FOLDER}/${EVENT}/${EDIT}/:eventId`,
  },
  {
    path: `${ROOT_FOLDER}/${AUTHORIZE}/:subRoute`,
  },
  {
    path: `${ROOT_FOLDER}/${MEMBER_PROFILE_MOBILE_SCREEN}/:userId`,
  },
  {
    path: `${ROOT_FOLDER}/:code`,
  },
];

// function withRouter(Component: ComponentType<any>) {
//   return forwardRef<any>((props, ref) => {
//     const location = useLocation();
//     const params = useParams();
//     const match = matchRoutes(parentPath, location.pathname);
//     const { goBack, replace, push, go, reload } = useHistory();

//     const router: IWithRoutes = {
//       location: {
//         ...location,
//         reload,
//       },
//       history: {
//         goBack,
//         replace,
//         push,
//         go,
//         reload,
//       },
//       params,
//       match: match && Array.isArray(match) ? match[0] : null,
//     };

//     return <Component {...props} {...router} ref={ref} />;
//   });
// }

function withRouter(Component: ComponentType<any>) {
  return forwardRef<any>((props, ref) => {
    const location = useLocation();
    const params = useParams();
    const match = matchRoutes(parentPath, location.pathname);
    const { goBack, replace, push, go, reload } = useHistory();

    const router: IWithRoutes = {
      location: {
        ...location,
        reload,
      },
      history: {
        goBack,
        replace,
        push,
        go,
        reload,
      },
      params,
      match: match && Array.isArray(match) ? match[0] : null,
    };

    return <Component {...props} {...router} ref={ref} />;
  });
}

const useRouter = () => {
  const location = useLocation();
  const params = useParams();
  const match = matchRoutes(parentPath, location.pathname);
  const { goBack, replace, push, go, reload } = useHistory();

  const router: IWithRoutes = {
    location: {
      ...location,
      reload,
    },
    history: {
      goBack,
      replace,
      push,
      go,
      reload,
    },
    params,
    match: match && Array.isArray(match) ? match[0] : null,
  };

  return router;
};

export { withRouter, useRouter };
